// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeartRateChart_chartShell__9bDSn {
  width: 100%;
  height: 100%;
  min-height: 340px;
  border-radius: 14px;
  background: color-mix(in srgb, var(--brand-text, #0f172a) 3%, transparent);
  border: 1px solid color-mix(in srgb, var(--brand-text, #0f172a) 8%, transparent);
  overflow: hidden;
  position: relative;
}

.HeartRateChart_chartShellDark__PbY4\\+ {
  background: #0d1117;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
}
`, "",{"version":3,"sources":["webpack://./src/features/trainingSummary/HeartRateChart.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0EAA0E;EAC1E,gFAAgF;EAChF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,0CAA0C;AAC5C","sourcesContent":[".chartShell {\n  width: 100%;\n  height: 100%;\n  min-height: 340px;\n  border-radius: 14px;\n  background: color-mix(in srgb, var(--brand-text, #0f172a) 3%, transparent);\n  border: 1px solid color-mix(in srgb, var(--brand-text, #0f172a) 8%, transparent);\n  overflow: hidden;\n  position: relative;\n}\n\n.chartShellDark {\n  background: #0d1117;\n  border-color: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartShell": `HeartRateChart_chartShell__9bDSn`,
	"chartShellDark": `HeartRateChart_chartShellDark__PbY4+`
};
export default ___CSS_LOADER_EXPORT___;
